/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { debounce } from '../../../api/apiUtils';
import AppLink from '../../../shared/components/app-link/AppLink';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import {
  editDaywiseAvailApi,
  getFlightDaywiseAvailRecord,
} from '../../../api/profileApi';
import AppModal from '../../../shared/components/app-modal/AppModal';
import EditCurrentAvailability from './EditCurrentAvailability';
import { getCurrentAvailCouponDetailForAgent } from '../../../api/flightApi';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import { isEmpty } from '../../../shared/helper-utils/appUtils';

function SeriesCurrentAvailability({ availableList }) {
  const allAvailableListRef = useRef(availableList);
  const [couponsList, setCouponsList] = useState(availableList);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [searchText, setSearchText] = useState('');
  const [sortParam, setSortParam] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const editCurrentAvailCouponRef = useRef(undefined);
  const [showEditCurrentAvailModal, setShowEditCurrentAvailModal] =
    useState(false);

  const handleFilter = debounce(() => {
    if (searchText !== '' && searchText !== null) {
      let data = [...allAvailableListRef.current];
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(searchText.toLowerCase()),
        ),
      );
      setCouponsList(data);
    }
  }, 500);

  const handleSort = (param) => {
    let order = 'asc';
    if (param === sortParam) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortParam(param);
    setSortOrder(order);
    const list = [...couponsList];
    if (param === 'couponId') {
      if (order === 'asc') {
        list.sort((a, b) => (a.CouponId > b.CouponId ? 1 : -1));
      } else {
        list.sort((a, b) => (b.CouponId > a.CouponId ? 1 : -1));
      }
    }
    if (param === 'couponDaywiseId') {
      if (order === 'asc') {
        list.sort((a, b) => (a.CouponDayWiseId > b.CouponDayWiseId ? 1 : -1));
      } else {
        list.sort((a, b) => (b.CouponDayWiseId > a.CouponDayWiseId ? 1 : -1));
      }
    }
    if (param === 'fromTo') {
      if (order === 'asc') {
        list.sort((a, b) =>
          `${a.Origin}-${a.Destination}`.localeCompare(
            `${b.Origin}-${b.Destination}`,
          ),
        );
      } else {
        list.sort((a, b) =>
          `${b.Origin}-${b.Destination}`.localeCompare(
            `${a.Origin}-${a.Destination}`,
          ),
        );
      }
    }
    if (param === 'flightNumber') {
      if (order === 'asc') {
        list.sort((a, b) =>
          `${a.CarrierCode}-${a.FlightNumber}`.localeCompare(
            `${b.CarrierCode}-${b.FlightNumber}`,
          ),
        );
      } else {
        list.sort((a, b) =>
          `${b.CarrierCode}-${b.FlightNumber}`.localeCompare(
            `${a.CarrierCode}-${a.FlightNumber}`,
          ),
        );
      }
    }
    if (param === 'depTime') {
      if (order === 'asc') {
        list.sort((a, b) => (a.DepTime > b.DepTime ? 1 : -1));
      } else {
        list.sort((a, b) => (b.DepTime > a.DepTime ? 1 : -1));
      }
    }
    if (param === 'arrTime') {
      if (order === 'asc') {
        list.sort((a, b) => (a.ArrTime > b.ArrTime ? 1 : -1));
      } else {
        list.sort((a, b) => (b.ArrTime > a.ArrTime ? 1 : -1));
      }
    }
    if (param === 'depDate') {
      if (order === 'asc') {
        list.sort((a, b) =>
          new Date(a.DepDate) > new Date(b.DepDate) ? 1 : -1,
        );
      } else {
        list.sort((a, b) =>
          new Date(b.DepDate) > new Date(a.DepDate) ? 1 : -1,
        );
      }
    }
    if (param === 'arrDate') {
      if (order === 'asc') {
        list.sort((a, b) =>
          new Date(a.ArrDate) > new Date(b.ArrDate) ? 1 : -1,
        );
      } else {
        list.sort((a, b) =>
          new Date(b.ArrDate) > new Date(a.ArrDate) ? 1 : -1,
        );
      }
    }
    if (param === 'startingfare') {
      if (order === 'asc') {
        list.sort((a, b) => (a.StartingFare > b.StartingFare ? 1 : -1));
      } else {
        list.sort((a, b) => (b.StartingFare > a.StartingFare ? 1 : -1));
      }
    }
    if (param === 'totalFare') {
      if (order === 'asc') {
        list.sort((a, b) => (a.TotalFare > b.TotalFare ? 1 : -1));
      } else {
        list.sort((a, b) => (b.TotalFare > a.TotalFare ? 1 : -1));
      }
    }
    if (param === 'totalSeats') {
      if (order === 'asc') {
        list.sort((a, b) => (a.TotalSeats > b.TotalSeats ? 1 : -1));
      } else {
        list.sort((a, b) => (b.TotalSeats > a.TotalSeats ? 1 : -1));
      }
    }
    if (param === 'availSeats') {
      if (order === 'asc') {
        list.sort((a, b) => (a.AvailSeats > b.AvailSeats ? 1 : -1));
      } else {
        list.sort((a, b) => (b.AvailSeats > a.AvailSeats ? 1 : -1));
      }
    }
    if (param === 'pnr') {
      if (order === 'asc') {
        list.sort((a, b) => a.PNR.localeCompare(b.PNR));
      } else {
        list.sort((a, b) => b.PNR.localeCompare(a.PNR));
      }
    }
    setCouponsList(list);
  };

  useEffect(() => {
    handleFilter();
  }, [searchText]);

  const getAvailDetailsForRecord = async (id) => {
    setIsLoading(true);
    const response = await getFlightDaywiseAvailRecord(id);
    if (response && response?.Root?.Status === 'OK') {
      const { FlightDaywiseavail } = response.Root.Result;
      if (
        FlightDaywiseavail !== '' &&
        FlightDaywiseavail !== undefined &&
        FlightDaywiseavail !== null
      ) {
        editCurrentAvailCouponRef.current = FlightDaywiseavail;
        setShowEditCurrentAvailModal(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Edit Current Availability',
          description: 'No records Available',
        });
      }
    }
    setIsLoading(false);
  };

  const handleEditFlightAvail = (id) => {
    getAvailDetailsForRecord(id);
  };

  const handleUpdateDaywiseAvailability = async (req) => {
    setShowEditCurrentAvailModal(false);
    setIsLoading(true);
    const res = await editDaywiseAvailApi(req);
    if (res && res.Root && res.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Update current Avail',
        description: res?.Root?.Message || 'Updated current Availability',
      });
      const currentAvailRes = await getCurrentAvailCouponDetailForAgent(
        getUserAgentId(),
      );
      if (
        currentAvailRes &&
        currentAvailRes.Root &&
        currentAvailRes.Root.Status === 'OK'
      ) {
        const { CouponFlightDetailList } = currentAvailRes.Root?.Result;
        if (
          CouponFlightDetailList !== '' &&
          CouponFlightDetailList !== undefined &&
          CouponFlightDetailList !== null
        ) {
          const { CouponFlightDetails } = CouponFlightDetailList;
          if (!isEmpty(CouponFlightDetails)) {
            const list = Array.isArray(CouponFlightDetails)
              ? CouponFlightDetails
              : [CouponFlightDetails];
            allAvailableListRef.current = list;
            setCouponsList(list);
          }
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Update current Avail',
        description:
          res?.Root?.Message || 'Failed to Update current Availability',
      });
    }
    setIsLoading(false);
  };

  return (
    <section>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <AppLoading isLoading={isLoading} />
      <div className="coupons-container p-1">
        {couponsList.length > 0 ? (
          <>
            <div className="p-3 filter-container">
              <AppTextInput
                label="search"
                name="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="overflow-auto table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      onClick={() => handleSort('couponDaywiseId')}
                      className="cursor-pointer"
                    >
                      Coupon DayWiseId
                    </th>
                    <th
                      onClick={() => handleSort('couponId')}
                      className="cursor-pointer"
                    >
                      Coupon Id
                    </th>
                    <th
                      onClick={() => handleSort('flightNumber')}
                      className="cursor-pointer"
                    >
                      Carrier/Flight No.
                    </th>
                    <th
                      onClick={() => handleSort('fromTo')}
                      className="cursor-pointer"
                    >
                      Sector
                    </th>
                    <th
                      onClick={() => handleSort('depDate')}
                      className="cursor-pointer"
                    >
                      Dep Date
                    </th>
                    <th
                      onClick={() => handleSort('depTime')}
                      className="cursor-pointer"
                    >
                      Dep Time
                    </th>
                    <th
                      onClick={() => handleSort('arrDate')}
                      className="cursor-pointer"
                    >
                      Arr Date
                    </th>
                    <th
                      onClick={() => handleSort('arrTime')}
                      className="cursor-pointer"
                    >
                      Arr Time
                    </th>
                    <th
                      onClick={() => handleSort('startingfare')}
                      className="cursor-pointer"
                    >
                      Starting fare
                    </th>
                    <th
                      onClick={() => handleSort('totalFare')}
                      className="cursor-pointer"
                    >
                      Total Fare
                    </th>
                    <th
                      onClick={() => handleSort('totalSeats')}
                      className="cursor-pointer"
                    >
                      Total Seats
                    </th>
                    <th
                      onClick={() => handleSort('availSeats')}
                      className="cursor-pointer"
                    >
                      Avail seats
                    </th>
                    <th
                      onClick={() => handleSort('pnr')}
                      className="cursor-pointer"
                    >
                      PNR
                    </th>
                    <th>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {couponsList.map((coupon) => (
                    <tr key={coupon.CouponId}>
                      <td>{coupon.CouponDayWiseId}</td>
                      <td>{coupon.CouponId}</td>
                      <td>
                        {coupon.CarrierCode}-{coupon.FlightNumber}
                      </td>
                      <td>{`${coupon.Origin}-${coupon.Destination}`}</td>
                      <td>{coupon.DepDate}</td>
                      <td>{coupon.DepTime}</td>
                      <td>{coupon.ArrDate}</td>
                      <td>{coupon.ArrTime}</td>
                      <td>{coupon.StartingFare.toFixed(1)}</td>
                      <td>{coupon.TotalFare.toFixed(1)}</td>
                      <td>{coupon.TotalSeats}</td>
                      <td>{coupon.AvailSeats}</td>
                      <td>{coupon.PNR}</td>
                      <td>
                        <AppLink
                          linkText="Edit"
                          onClick={() =>
                            handleEditFlightAvail(coupon.CouponDayWiseId)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="max-width fs-14 fw-500 text-center mt-2">
            Currently not available
          </div>
        )}
      </div>
      {showEditCurrentAvailModal && (
        <AppModal
          modalTitle={`Edit current availability ${editCurrentAvailCouponRef.current.Recordid}`}
          showCloseButton
          onModalClose={() => setShowEditCurrentAvailModal(false)}
          size="lg"
        >
          <EditCurrentAvailability
            coupon={editCurrentAvailCouponRef.current}
            onUpdateCurrentAvail={handleUpdateDaywiseAvailability}
          />
        </AppModal>
      )}
    </section>
  );
}

export default SeriesCurrentAvailability;
